import { Collapse } from "@mui/material";
import { breackpoints, textContent } from "../services/constants";

export const TextParagraphs = ({ text, expanded, showStrings, left }) => {
  const vw = window.innerWidth;
  const textArr = text.split("\n");
  return (
    <div
      className={`px-0 ${
        left ? "md:pr-4" : "md:pl-4"
      } text-[4vw] md:text-[1.5vw] md:w-3/5`}
    >
      {textArr.slice(0, showStrings).map((el, idx) => (
        <p className={`py-[0.15rem] md:py-1 `} key={idx}>
          {el}
        </p>
      ))}

      <Collapse
        in={expanded || vw > breackpoints.md}
        timeout={600}
        unmountOnExit
      >
        {textArr.slice(showStrings).map((el, idx) => (
          <p key={idx} className="py-[0.15rem] md:py-1">
            {el}
          </p>
        ))}
      </Collapse>
      {!expanded && vw < breackpoints.md ? null : (
        <div className="flex justify-start flex-wrap">
          <span className="pr-2">Щоб замовити екскурсію пишіть у</span>
          <a
            href={textContent.contact.whatsapp}
            target="_blank"
            rel="noreferrer noopener"
            className="text-customBrown font-bold pr-2"
          >
            WhatsApp
          </a>
          <span className="pr-2">чи в</span>
          <a
            href={textContent.contact.instagram}
            target="_blank"
            rel="noreferrer noopener"
            className="text-customBrown font-bold pr-2"
          >
            Instagram
          </a>
          <span>{textContent.contact.instaShort}</span>
        </div>
      )}
    </div>
  );
};
